import {config,endpoint} from './config'

export async function requestSelfRecovery(email:string){
  await fetch(endpoint(config.endpoints.selfRecovery),{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({email})})
  return 'If an eligible account exists, recovery instructions have been sent.'
}
